import { Query } from 'react-apollo';
import {
  AvailableOrganizationCoachingSessions,
  AvailableOrganizationCoachingSessionsVariables,
} from 'coaching/queries/__generated__/AvailableOrganizationCoachingSessions';
import AVAILABLE_ORGANIZATION_COACHING_SESSIONS from 'coaching/queries/AvailableOrganizationCoachingSessions.gql';
import { isNotNullOrUndefined } from 'types/typescript/util';
import moment from 'moment-timezone';
import * as React from 'react';
import { AvailableSessionsContainerProps } from 'coaching/containers/GetPossibleCoachingSessionsForCoachContainer';

export function AvailableOrganizationCoachingSessionsContainer(
  props: AvailableSessionsContainerProps
) {
  return (
    <Query<AvailableOrganizationCoachingSessions, AvailableOrganizationCoachingSessionsVariables>
      query={AVAILABLE_ORGANIZATION_COACHING_SESSIONS}
      variables={{
        frequency: props.frequency,
        startDateTimeRange: props.startDateTimeRange,
        endDateTimeRange: props.endDateTimeRange,
        participantUuid: props.participantUuid,
      }}>
      {({ loading, error, data }) => {
        return props.children({
          sessionSlots: data?.coaching_availableOrganizationCoachingSessions?.availableSessions
            .filter(isNotNullOrUndefined)
            .map(res => ({
              coachUuid: res.coachUuid,
              startDateTime: moment(res.startDateTime),
              endDateTime: moment(res.endDateTime),
            })),
          timeOff: data?.coaching_availableOrganizationCoachingSessions?.timeOff
            .filter(isNotNullOrUndefined)
            .map(res => ({
              startDate: moment(res.startDate),
              endDate: moment(res.endDate),
            })),
          loading,
          error,
        });
      }}
    </Query>
  );
}
